<template>
  <div class="row">
    <div class="col-lg-4">
      <p>
        <b>{{ $t('employee') }}: </b>{{ item.name }} ({{ item.email }}) <label
          class="badge badge-primary">{{ $t(item.role) }}</label>
      </p>
      <p v-if="item.group">
        <b>{{ $t('group') }}: </b>{{ item.group.name }}
      </p>
      <p v-if="item.department">
        <b>{{ $t('department') }}: </b>{{ item.department.name }}
      </p>
    </div>
    <div class="col-lg-4">
      <p>
        <b>{{ $t('licenceRevenue') }}: </b>
        <span v-if="dataLoading"><b-spinner small></b-spinner></span>
        <span v-else-if="sumLicenceRevenue">{{ sumLicenceRevenue | numFormat }}</span>
        <span v-else>0</span>
      </p>
      <p>
        <b>{{ $t('licenceCommission') }}: </b>
        <span v-if="dataLoading"><b-spinner small></b-spinner></span>
        <span v-else-if="sumLicenceCommission">{{ sumLicenceCommission | numFormat('0,0.0') }}</span>
        <span v-else>0</span>
      </p>
      <p v-if="!dataLoading && licenceDetails.length > 0">
        <a type="button-link" href="javascript:;" @click="showLicenceDetail = true">>> {{ $t('licenceDetail') }}</a>
      </p>
    </div>
    <div class="col-lg-4">
      <p>
        <b>{{ $t('callFeeRevenue') }}: </b>
        <span v-if="dataLoading"><b-spinner small></b-spinner></span>
        <span v-else-if="sumCallFeeRevenue">{{ sumCallFeeRevenue | numFormat }}</span>
        <span v-else>0</span>
      </p>
      <p>
        <b>{{ $t('callFeeCommission') }}: </b>
        <span v-if="dataLoading"><b-spinner small></b-spinner></span>
        <span v-else-if="sumCallFeeCommission">{{ sumCallFeeCommission | numFormat('0,0.0') }}</span>
        <span v-else>0</span>
      </p>
      <p v-if="!dataLoading && sumCallFeeRevenue">
        <a type="button-link" href="javascript:;" @click="showCallFeeDetail = true">>> {{ $t('callFeeDetail') }}</a>
      </p>
    </div>
    <b-modal v-model="showLicenceDetail" size="xl" :title="$t('licenceDetailTitle', [item.name, getMonth])"
             no-close-on-backdrop ok-only scrollable>
      <div class="col-12">
        <div class="c-smart-table">
          <div class="row">
            <div class="col-lg-6 text-right"><b>{{ $t('sumLicenceRevenue') }}</b></div>
            <div class="col-lg-2 text-center"><b>{{ sumLicenceRevenue | numFormat(0.00) }}</b></div>
            <div class="col-lg-2 text-right"><b>{{ $t('sumLicenseCommission') }}</b></div>
            <div class="col-lg-2 text-right"><b>{{ sumLicenceCommission | numFormat(0.00) }}</b></div>
          </div>
          <div class="row c-smart-table__title">
            <div class="col-lg-1">#</div>
            <div class="col-lg-3">{{ $t('planOrder') }}</div>
            <div class="col-lg-2">{{ $t('commissionType') }}</div>
            <div class="text-center col-lg-2">{{ $t('planOrderValue') }}</div>
            <div class="text-center col-lg-2">{{ $t('commissionPercent') }}</div>
            <div class="text-right col-lg-2">{{ $t('commissionValue') }}</div>
          </div>
          <div class="row" v-for="(detail, index) in licenceDetails" :key="detail._id">
            <div class="col-lg-1">{{ index + 1 }}</div>
            <div class="col-lg-3">
              <p>
                <b>{{ $t('client') }}: </b>{{ detail.companyName }} ({{ detail.domain }})
              </p>
              <p>
                <b>{{ $t('planOrderType') }}: </b>{{ $t(detail.planOrderType) }}
              </p>
              <p>
                <b>{{ $t('numberOfUser') }}: </b>{{ detail.numberOfUser | numFormat }}
              </p>
              <p>
                <b>{{ $t('userPrice') }}: </b>{{ detail.userPrice | numFormat }}
              </p>
              <p>
                <b>{{ $t('monthCount') }}: </b>{{ detail.monthCount | numFormat('0,0.0') }}
              </p>
              <p>
                <b>{{ $t('planOrderValue') }}: </b>{{ detail.planOrderValue | numFormat }}
              </p>
              <p>
                <b>{{ $t('agencyCommission') }}: </b>{{ detail.agencyCommission }}
              </p>
              <p>
                <b>{{ $t('createTime') }}: </b>{{ detail.createTime | moment('DD/MM/YYYY HH:mm:ss') }}
              </p>
            </div>
            <div class="col-lg-2">
              <b class="c-smart-table__label">{{ $t('commissionType') }}: </b>{{ $t(detail.role) }}
            </div>
            <div class="col-lg-2 text-center">
              <b class="c-smart-table__label">{{ $t('planOrderValue') }}: </b>{{ detail.planOrderValue | numFormat }}
            </div>
            <div class="col-lg-2 text-center">
              <b class="c-smart-table__label">{{ $t('commissionPercent') }}: </b>{{ detail.percent }}%
            </div>
            <div class="col-lg-2 text-right">
              <b class="c-smart-table__label">{{
                  $t('commissionValue')
                }}: </b>{{ commissionValue(detail) | numFormat('0,0.0') }}
            </div>
          </div>
        </div>
      </div>
    </b-modal>
    <b-modal v-model="showCallFeeDetail" size="xl" :title="$t('callFeeDetailTitle', [item.name, getMonth])"
             no-close-on-backdrop ok-only scrollable>
      <div class="col-12">
        <div class="c-smart-table">
          <div class="row">
            <div class="col-lg-3 text-right"><b>{{ $t('sumCallFeeRevenue') }}</b></div>
            <div class="col-lg-2"><b>{{ sumCallFeeRevenue | numFormat }}</b></div>
            <div class="col-lg-5 text-right"><b>{{ $t('sumCallFeeCommission') }}</b></div>
            <div class="col-lg-2 text-right"><b>{{ sumCallFeeCommission | numFormat('0,0.0') }}</b></div>
          </div>
          <div class="row c-smart-table__title">
            <div class="col-lg-1">#</div>
            <div class="col-lg-2">{{ $t('client') }}</div>
            <div class="col-lg-6">{{ $t('callFee') }}</div>
            <div class="text-center col-lg-1">{{ $t('commissionPercent') }}</div>
            <div class="text-right col-lg-2">{{ $t('commissionValue') }}</div>
          </div>
          <div class="row" v-for="(detail, index) in callFeeDetails" :key="index">
            <div class="col-lg-1">{{ index + 1 }}</div>
            <div class="col-lg-2">
              <b class="c-smart-table__label">{{ $t('client') }}: </b>{{ detail.client.companyName }}
              ({{ detail.client.domain }})
            </div>
            <div class="col-lg-6">
              <p><b>{{ $t('regularCallFee') }}: </b>{{ detail.regularCallFee | numFormat }}</p>
              <p>
                <b>{{ $t('packageCallFee') }}: </b>{{ detail.packageCallFee | numFormat }}
                <a v-if="detail.clientPackages && detail.clientPackages.length" href="javascript:;"
                   @click="showPackageDetail(detail.clientPackages, detail.client.companyName)">
                  >> {{ $t('detail') }}
                </a>
              </p>
              <p><b>{{ $t('totalCallFee') }}: </b>{{ detail.regularCallFee + detail.packageCallFee | numFormat }}</p>
              <p>
                <b>{{
                    $t('baseCallFee')
                  }}: </b>{{ detail.client.baseCallFee ? detail.client.baseCallFee : 0 | numFormat }}
              </p>
              <p>
                <b>{{ $t('callFeeToGetCommission') }}: </b>
                {{ callFeeToGetCommission(detail)| numFormat('0,0.0') }}
              </p>
            </div>
            <div class="text-center col-lg-1">
              <b class="c-smart-table__label">{{ $t('commissionPercent') }}: </b>{{ detail.percent }}%
            </div>
            <div class="text-right col-lg-2">
              <b class="c-smart-table__label">{{
                  $t('commissionValue')
                }}: </b>{{ callFeeCommissionValue(detail) | numFormat('0,0.0') }}
            </div>
          </div>
        </div>
      </div>
    </b-modal>
    <b-modal v-model="showPackageCallFeeDetail" size="xl"
             :title="$t('packageCallFeeDetailTitle', [clientCompanyName, getMonth])" no-close-on-backdrop ok-only
             scrollable>
      <div class="col-12">
        <div class="c-smart-table">
          <div class="row c-smart-table__title">
            <div class="col-lg-1">#</div>
            <div class="col-lg-2">{{ $t('createTime') }}</div>
            <div class="col-lg-2">{{ $t('numberOfPackage') }}</div>
            <div class="text-center col-lg-1">{{ $t('monthCount') }}</div>
            <div class="text-center col-lg-2">{{ $t('total') }}</div>
            <div class="text-center col-lg-2">{{ $t('expireTime') }}</div>
            <div class="text-right col-lg-2">{{ $t('note') }}</div>
          </div>
          <div class="row" v-for="(p, index) in clientPackages" :key="p._id">
            <div class="col-lg-1">{{ index + 1 }}</div>
            <div class="col-lg-2">{{ p.createTime | moment('DD/MM/YYYY HH:mm:ss') }}</div>
            <div class="col-lg-2">{{ p.limit }}</div>
            <div class="text-center col-lg-1">{{ p.monthCount }}</div>
            <div class="text-center col-lg-2">{{ p.total | numFormat }}</div>
            <div class="text-center col-lg-2">{{ p.expireTime | moment('DD/MM/YYYY HH:mm:ss') }}</div>
            <div class="text-right col-lg-2">{{ p.note ? p.note : $t('notUpdated') }}</div>
          </div>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import moment from "moment";

export default {
  props: ['item', 'filter'],
  data() {
    return {
      dataLoading: true,
      sumLicenceRevenue: 0,
      sumLicenceCommission: 0,
      licenceDetails: [],
      sumCallFeeRevenue: 0,
      sumCallFeeCommission: 0,
      callFeeDetails: [],
      showLicenceDetail: false,
      showCallFeeDetail: false,
      showPackageCallFeeDetail: false,
      clientCompanyName: null,
      clientPackages: [],
      trigger: this.filter.trigger
    }
  },
  computed: {
    getMonth() {
      return moment(this.time).format('MM/YYYY');
    }
  },
  methods: {
    load: async function () {
      this.dataLoading = true;
      let filter = {
        from: moment(this.filter.time).startOf('month').format('x'),
        to: moment(this.filter.time).endOf('month').format('x')
      }
      let response = await this.$bgService.get(`/commission/license/${this.item._id}`, {params: filter});
      if (response.data && response.data.length) {
        let rev = response.data.filter(f => f.role === 'sales' || f.role === 'kpiSales');
        if (rev.length) {
          this.sumLicenceRevenue = rev.map(d => d.planOrderValue).reduce((a, b) => a + b);
        }
        this.sumLicenceCommission = response.data.map(d => (d.planOrderValue - d.agencyCommission) * d.percent / 100).reduce((a, b) => a + b);
        this.licenceDetails = response.data;
      }
      //cước gọi
      if (['manager', 'supervisor', 'sales', 'kpiSales', 'account', 'operationsManager'].includes(this.item.role)) {
        filter.role = this.item.role;
        let response = await this.$bgService.get(`/commission/call-fee/${this.item._id}`, {params: filter});
        if (response.data && response.data.length) {
          this.sumCallFeeRevenue = response.data.map(d => d.regularCallFee + d.packageCallFee).reduce((a, b) => a + b);
          this.sumCallFeeCommission = response.data.map(d => this.callFeeCommissionValue(d)).reduce((a, b) => a + b);
          this.callFeeDetails = response.data;
        }
      }
      this.dataLoading = false;
    },
    commissionValue(detail) {
      return detail.percent * (detail.planOrderValue - detail.agencyCommission) / 100
    },
    callFeeToGetCommission(detail) {
      let fee = 0
      if (['operationsManager', 'account'].includes(this.item.role)) {
        fee = detail.regularCallFee + detail.packageCallFee
      } else if (detail.client.baseCallFee) {
        fee = detail.regularCallFee + detail.packageCallFee > detail.client.baseCallFee ? detail.regularCallFee + detail.packageCallFee - detail.client.baseCallFee : 0
      } else {
        fee = detail.regularCallFee + detail.packageCallFee
      }
      return fee / 11 * 10
    },
    callFeeCommissionValue(detail) {
      return this.callFeeToGetCommission(detail) * detail.percent / 100
    },
    showPackageDetail(clientPackages, clientCompanyName) {
      this.clientPackages = clientPackages;
      this.clientCompanyName = clientCompanyName;
      this.showPackageCallFeeDetail = true;
    }
  },
  watch: {
    filter: {
      handler(val) {
        if (val.trigger !== this.trigger) {
          this.load();
        }
        this.trigger = val.trigger;
      }, deep: true
    }
  },
  mounted() {
    this.load();
  },
  i18n: {
    messages: {
      en: {
        sumLicenceRevenue: "Sum licence revenue",
        sumLicenseCommission: 'Sum licence commission',
        planOrder: 'Plan order',
        commissionType: 'Commission type',
        planOrderValue: 'Plan order value',
        commissionPercent: 'Commission percent',
        commissionValue: 'Commission value',
        planOrderType: 'Plan order type',
        numberOfUser: 'Number of user',
        userPrice: 'User price',
        agencyCommission: 'Agency commission',
        licenceDetailTitle: 'Licence commission detail of {0} in {1}',
        callFeeDetailTitle: 'Call fee commission detail of {0} in {1}',
        packageCallFeeDetailTitle: 'Package call fee detail of {0} in {1}',
        licenceDetail: 'Licence detail',
        callFeeDetail: 'Call fee detail',
        sumCallFeeRevenue: 'Sum call fee revenue',
        sumCallFeeCommission: 'Sum call fee commission',
        callFee: 'Call fee',
        new: 'New',
        user: 'Buy more user',
        upgrade: 'Upgrade',
        extend: 'Extend',
        monthCount: 'Number of month',
        licenceRevenue: 'Licence revenue',
        licenceCommission: 'Licence commission',
        callFeeRevenue: 'Call fee revenue',
        callFeeCommission: 'Call fee commission',
        baseCallFee: 'Base call fee',
        callFeeToGetCommission: 'Call fee to get commission',
        totalCallFee: 'Total call fee',
        regularCallFee: 'Regular call fee',
        packageCallFee: 'Package call fee',
        showPackageDetail: 'Show package detail',
        numberOfPackage: 'Number of package'
      },
      vi: {
        sumLicenceRevenue: "Tổng doanh thu licence",
        sumLicenseCommission: 'Tổng hoa hồng licence',
        planOrder: 'Đơn hàng',
        commissionType: 'Loại hoa hòng',
        planOrderValue: 'Giá trị đơn hàng',
        commissionPercent: 'Phần trăm hoa hồng',
        commissionValue: 'Giá trị hoa hồng',
        planOrderType: 'Loại đơn hàng',
        numberOfUser: 'Số user',
        userPrice: 'Đơn giá/ user',
        agencyCommission: 'Hoa hồng đại lý',
        licenceDetailTitle: 'Chi tiết hoa hồng licence. Nhân viên: {0}. Tháng {1}',
        callFeeDetailTitle: 'Chi tiết hoa hồng cước gọi. Nhân viên: {0}. Tháng {1}',
        packageCallFeeDetailTitle: 'Chi tiết cước trọn gói. Khách hàng: {0}. Tháng {1}',
        licenceDetail: 'Chi tiết licence',
        callFeeDetail: 'Chi tiết cước gọi',
        sumCallFeeRevenue: 'Tổng doanh thu cước gọi',
        sumCallFeeCommission: 'Tổng hoa hồng cước gọi',
        callFee: 'Cước gọi',
        new: 'Mua mới',
        user: 'Mua thêm user',
        upgrade: 'Nâng cấp',
        extend: 'Gia hạn',
        monthCount: 'Số tháng',
        licenceRevenue: 'Doanh thu licence',
        licenceCommission: 'Hoa hồng licence',
        callFeeRevenue: 'Doanh thu cước gọi',
        callFeeCommission: 'Hoa hồng cước gọi',
        baseCallFee: 'Cước nền',
        callFeeToGetCommission: 'Cước được tính hoa hồng',
        totalCallFee: 'Tổng cước gọi',
        regularCallFee: 'Cước gọi thường',
        packageCallFee: 'Cước trọn gói',
        showPackageDetail: 'Chi tiết cước trọn gói',
        numberOfPackage: 'Số gói'
      }
    }
  }
}
</script>

<style scoped>

</style>